
const validate = (props) => {
    const errors = {}

    if (!props.newPassword) {
        errors.newPassword = 'يرجي ادخال كلمة المرور'
    } else if (props.newPassword.length < 8) {
        errors.newPassword = 'كلمة المرور ضعيفة'
    }

    if (!props.confirmpassword) {
        errors.confirmpassword = 'يرجي ادخال تاكيد كلمة المرور'
    } else if (props.newPassword !== props.confirmpassword) {
        errors.confirmpassword = 'كلمة المرور غير متطابقتان'
    }

    return errors
}

export default validate;